import { Component, Input, OnInit } from "@angular/core";
import { LanguageType } from "app/shared/types/language.type";
import { LANGUAGES } from "app/languages";
import { AccountService } from "app/shared/services/account.service";
import { AppTranslateService } from "app/shared/services/app-translate.service";

@Component({
  selector: "sso-error",
  templateUrl: "./sso-error.component.html",
  styleUrls: ["./sso-error.component.scss"],
  standalone: false,
})
export class SsoErrorComponent {
  fallbackLanguage: LanguageType = LANGUAGES[0];
  browserLanguage: LanguageType = this.fallbackLanguage;

  @Input()
  isMobileWebView = false;
  languages = LANGUAGES;
  constructor(
    private readonly accountService: AccountService,
    private readonly appTranslateService: AppTranslateService,
  ) {}

  ngOnInit() {
    const localStorageLanguage = localStorage.getItem("cariloop:language");
    if (localStorageLanguage === null || localStorageLanguage === "") {
      this.browserLanguage =
        LANGUAGES.find(
          ({ value }) => value === window.navigator.language.substring(0, 2),
        ) ?? LANGUAGES[0];

      this.appTranslateService.updateLang(this.browserLanguage.value);

      return;
    }

    const parsedLanguage = JSON.parse(localStorageLanguage);
    this.browserLanguage =
      LANGUAGES.find(({ value }) => value === parsedLanguage?.value) ??
      LANGUAGES[0];
  }

  changeLanguage(language: string) {
    const newLanguage = LANGUAGES.find(({ value }) => value === language);

    this.accountService.setLocalLanguage(newLanguage);

    this.appTranslateService.updateLang(language);

    return newLanguage;
  }
}
